import { createReducer, on, Action } from '@ngrx/store';
import * as fromModels from '@models';
import * as etlActions from '@etl/etl.actions';

export const etlFeatureKey = 'etl';

export enum errorTypes {
  fetching = 'fetching',
  creating = 'creating',
  editing = 'editing',
  deleting = 'deleting',
  startingJob = 'startingJob',
}

export interface EtlState {
  collection: fromModels.Etl[];
  row: fromModels.Etl;
  error: Error;
  errorType: errorTypes;

  isFetching: boolean;
  hasError: boolean;
  successfullyAdded: boolean;
  successfullyEdited: boolean;
  successfullyDeleted: boolean;
  successfullyLoaded: boolean;
  actionStarted: boolean;
}

export const initialState: EtlState = {
  collection: [],
  row: null,
  error: null,
  errorType: null,

  isFetching: false,
  hasError: false,
  successfullyAdded: false,
  successfullyEdited: false,
  successfullyDeleted: false,
  successfullyLoaded: false,
  actionStarted: false,
};

const etlReducer = createReducer(
  initialState,

  on(etlActions.create, (state, payload) => (
    Object.assign({}, state, {
      successfullyAdded: false,
      row: payload.row,
      error: null,
      hasError: false,
    })
  )),

  // resultado de la insercion de una nueva fila en el State
  on(etlActions.rowAdded, (state, payload) => {
    const itemAdded = Object.assign({}, state, {
      collection: [...state.collection, payload.row],
      successfullyAdded: true,
      row: payload.row,
      error: null,
      hasError: false,
      errorType: null,
    });
    return itemAdded;
  }),

  on(etlActions.remove, (state, payload) => (
    Object.assign({}, state, {
      successfullyDeleted: false,
      hasError: false,
      row: payload.row,
    })
  )),

  // elimino una fila del state
  on(etlActions.rowWasDeleted, (state, payload) => {
    const id = payload.row.id;
    const objIndex = state.collection.findIndex(r => r.id === id);
    const newState = Object.assign({}, state, {
      collection: [
        ...state.collection.slice(0, objIndex),
        ...state.collection.slice(objIndex + 1),
      ],
      row: null,
      successfullyDeleted: true,
      errorType: null,
      hasError: false,
    });

    return newState;
  }),

  // inicia la carga de los datos
  on(
    etlActions.getCollection,
    etlActions.getCompanyJobs,
    state => {
    return Object.assign({}, state, {
      actionStarted: false,
      isFetching: true,
      collection: [],
      errorType: null,
      error: null,
    });
  }),

  // retorna los datos cargados
  on(etlActions.collectionLoaded, (state, payload) => (
    Object.assign({}, state, {
      collection: payload.newCollection,
      isFetching: false,
      // errorType: null,
    })
  )),

  on(etlActions.update, (state, payload) => Object.assign({}, state, {
      successfullyEdited: false,
      row: payload.row,
    })
  ),

  // resultado de la edicion de la fila en el State
  on(etlActions.rowEdited, (state, payload) => {
    const posEdited = state.collection.findIndex(
      r => r.id === payload.row.id);

    const newState = Object.assign({}, state, {
      collection: [
        ...state.collection.slice(0, posEdited),
        payload.row,
        ...state.collection.slice(posEdited + 1),
      ],
      successfullyEdited: true,
      actionStarted: false,
      row: payload.row,
      errorType: null,
      ...state.collection
    });

    return newState;
  }),

  on(etlActions.resetParams, (state, payload) => (
    Object.assign({}, state, {
      row: payload.row,
      successfullyAdded: false,
      successfullyEdited: false,
      successfullyDeleted: false,
      errorType: null,
    })
  )),

  on(etlActions.setRow, (state, payload) => (
    Object.assign({}, state, {
      successfullyAdded: false,
      successfullyEdited: false,
      successfullyDeleted: false,
      row: payload.row,
    })
  )),

  on(etlActions.startAction, (state, payload) => (
    Object.assign({}, state, {
      actionStarted: false,
      row: payload.row,
      errorType: null,
      hasError: false,
    })
  )),

  on(etlActions.startActionSuccess, (state, payload) => {
    const posEdited = state.collection.findIndex(
      r => r.id === payload.row.id
    );

    return Object.assign({}, state, {
      collection: [
        ...state.collection.slice(0, posEdited),
        payload.row,
        ...state.collection.slice(posEdited + 1),
      ],
      actionStarted: true,
      errorType: null,
      row: payload.row,
    });
  }),

  // ocurrio un error
  on(etlActions.failRequest, (state, payload) => (
    Object.assign({}, state, {
      hasError: true,
      row: null,
      error: payload.error,
      errorType: payload.errorType,
      isFetching: false,
    })
  )),

  on(etlActions.jobDetails, (state, payload) => (
    Object.assign({}, state, {
      row: null, successfullyLoaded: false, errorType: null, error: null,
      isFetching: true,
    })
  )),
  on(etlActions.jobDetailsLoaded, (state, payload) => (
    Object.assign({}, state , {
      row: payload.row, finished: payload.finished, isFetching: false,
    })
  )),
);

export function reducer(state: EtlState | undefined, action: Action) {
  return etlReducer(state, action);
}
